
function convertErrors(data) {
  var errors_ = {}
  if (data) {
      Object.keys(data).forEach(f => {
        if (f != 'detail') {
          //console.log("f", f, data[f])
          Object.keys(data[f]).forEach(j => {
            //console.log("j", j, data[f][j])
            errors_[j] = data[f][j]
            //Object.keys(data[f][j]).forEach(k => {
              //errors_[k] = data[f][j][k]
            //})
          })
        }
      })

      //console.log("errors_", errors_)

      if (data["detail"] != null) {
        Object.keys(data["detail"]).forEach(f => {
            let loc = data["detail"][f]["loc"].slice(1)
            let msg = data["detail"][f]["msg"]


            Object.keys(loc).forEach(i => {
                if (i == Object.keys(loc).length - 1) {
                    errors_[loc[i]] = msg.charAt(0).toUpperCase() + msg.slice(1);
                }
                //errors_ = ref[loc[i]]
                
            })
            //ref = msg
        })  
      }
    return errors_
  } 
  return data
}

export { convertErrors }